import React from "react";
import { Panel, StatusBadge } from "../../components/ui/dashboard";

const DriverApp: React.FC = () => {
  return (
    <div className="p-3 sm:p-4 md:p-6 space-y-4">
      <Panel title="Assigned Trip" subtitle="Mobile responsive driver view">
        <div className="space-y-2 text-sm">
          <p><span className="font-semibold">Pickup:</span> Plot 19, Nashik MIDC</p>
          <p><span className="font-semibold">Delivery:</span> Metro Retail, Pune</p>
          <p><span className="font-semibold">Items:</span> Steel rods, 1200 kg</p>
          <StatusBadge label="in_transit" tone="info" />
        </div>
      </Panel>

      <Panel title="Update Status" subtitle="picked up -> checkpoint -> delivered">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
          <button className="px-3 py-2 rounded-lg bg-blue-50 text-blue-700 text-sm">Picked Up</button>
          <button className="px-3 py-2 rounded-lg bg-amber-50 text-amber-700 text-sm">Checkpoint</button>
          <button className="px-3 py-2 rounded-lg bg-emerald-50 text-emerald-700 text-sm">Delivered</button>
        </div>
      </Panel>

      <Panel title="Trip Charges" subtitle="Visible assigned charges">
        <div className="text-sm text-slate-700 space-y-1">
          <p>Loading: INR 1,000</p>
          <p>Toll: INR 850</p>
          <p>Fuel Surcharge: INR 1,600</p>
        </div>
      </Panel>
    </div>
  );
};

export default DriverApp;